<template>
  <!-- 分享组件 -->
  <van-overlay :show="showShare" @click="bindClose" :z-index="zIndex">
    <div class="share-container">
      <div class="top">
        <div style="width: 100%; height: 100%" @click.stop v-if="imgUrl">
          <img class="poster-image" :src="imgUrl" alt="" />
        </div>
      </div>
      <div class="share-content" @click.stop>
        <div class="title">分享到</div>
        <div class="close iconfont icon-cha" @click="bindClose"></div>
        <div class="list-scroll">
          <div class="list">
            <div
              class="item"
              v-for="(item, index) in list"
              :key="index"
              @click="bindClick(index)"
            >
              <div
                class="item-icon"
                :ref="'icon' + index"
                :data-clipboard-text="copyUrl"
                :style="{ animationDelay: 0.3 + 0.1 * index + 's' }"
              >
                <img class="icon-img" :src="item.icon" alt="" />
              </div>
              <div class="item-name">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </van-overlay>
</template>
<script>
import Clipboard from 'clipboard'
import { shareData, eventObj } from './data'
import html2canvas from 'html2canvas'
export default {
  props: {
    //需要隐藏的iconid
    hideIconId: {
      type: Array | Number | String,
      default: ''
    },
    zIndex: {
      default: Number | String,
      default: 1000
    },
    value: {
      type: Boolean,
      default: false
    },
    //分享类型 0表示默认分享图片  1表示分享链接
    shareType: {
      type: Number,
      default: 0
    },
    //分享参数 包括标题 描述以及缩略图
    shareOptions: {
      type: Object,
      default: () => {
        return {
          desc: 'betterWE星球',
          title: 'betterWE星球',
          thumbnail:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_logo.png'
        }
      }
    },
    //复制的链接
    copyUrl: {
      type: String,
      default: ''
    },
    posterId: {
      type: String,
      default: 'poster'
    }
  },
  data() {
    return {
      showShare: false,
      clipboard: null,
      creatingPoster: false,
      curShareType: 0,
      imgUrl: '',
      list: [], //
      shareData
    }
  },
  watch: {
    value() {
      this.updateParams()
    }
  },
  created() {
    this.updateParams()
  },
  mounted() {},
  methods: {
    updateParams() {
      this.showShare = this.value
      this.curShareType = this.shareType
      setTimeout(() => {
        this.updateIcon()
      }, 300)
      if (this.shareType == 0 && this.value) {
        this.isCreatePoster()
      }
    },
    //是否生成海报
    isCreatePoster() {
      if (this.curShareType == 0) {
        this.createPoster(this.posterId)
      }
    },
    //生成海报
    createPoster(id) {
      if (this.creatingPoster) {
        return
      }
      let dom = document.getElementById(id)
      if (!dom) {
        this.$toast('未获取到分享图')
        return
      }
      this.creatingPoster = true
      this.$toast.loading('正在生成图片...')
      html2canvas(dom, {
        backgroundColor: null,
        useCORS: true
      })
        .then((canvas) => {
          this.$toast.clear()
          this.imgUrl = canvas.toDataURL()
          this.$toast('图片已生成')
          this.curShareType = 0
          this.updateIcon()
          this.showShare = true
        })
        .catch((err) => {})
        .finally(() => {
          this.creatingPoster = false
        })
    },
    //更新图标
    updateIcon() {
      if (this.curShareType >= this.shareData.length) {
        this.$toast('分享类型不能大于等于' + this.shareData.length)
        return
      }
      let list = this.shareData[this.curShareType].data
      if (this.hideIconId) {
        let isArray = Array.isArray(this.hideIconId)
        list.map((item) => {
          if (isArray && this.hideIconId.includes(item.id)) {
            item.hidden = true
          } else if (!isArray && item.id == this.hideIconId) {
            item.hidden = true
          }
        })
      }
      /* 过滤掉需要隐藏的 */
      list = list.filter((item) => {
        return !item.hidden
      })
      this.list = list
      this.$nextTick(() => {
        this.addEventCopy()
      })
    },
    //监听复制事件
    addEventCopy() {
      this.list.map((item, index) => {
        if (item.name == '复制链接') {
          let dom = this.$refs['icon' + index]
          console.dir(dom)
          dom = Array.isArray(dom) ? dom[0] : dom
          this.clipboard = new Clipboard(dom)
          this.clipboard.on('success', () => {
            this.$toast('复制链接成功,快去分享给你的好友吧')
          })
          this.clipboard.on('error', () => {
            this.$toast('复制失败，请手动复制')
          })
        }
      })
    },
    bindClick(index) {
      let close = this.list[index].close
      let func = eventObj[this.list[index].func]
      func && func(this)
      if (close) {
        this.$emit('input', false)
      } else {
        this.showShare = false
      }
    },
    bindClose() {
      this.$emit('input', false)
      this.resetData()
    },
    resetData() {
      this.imgUrl = ''
    }
  }
}
</script>
<style lang="scss" scoped>
.share-container {
  height: 100%;
  display: flex;
  align-items: stretch;
  flex-direction: column;

  .top {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    padding: 20px;
    padding-top: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    .poster-image {
      width: 100%;
      height: 100%;
      object-fit: contain;
      animation: mymove 0.3s ease;
    }
  }
}
@keyframes mymove {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0%);
  }
}
.share-content {
  position: relative;
  width: 100%;
  background: #f9f9f9;
  padding: 17px 20px;
  box-sizing: border-box;
  animation: moveup 0.3s ease;

  .title {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 20px;
    margin-bottom: 20px;
  }

  .close {
    position: absolute;
    padding: 10px;
    top: 5px;
    right: 5px;
    color: #000;
    font-size: 14px;
  }

  .list-scroll {
    //max-height: 190px;
    /*  overflow-y: scroll; */
  }

  .list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .item {
      width: 25%;
      margin-bottom: 10px;

      .item-icon {
        margin: 0 auto;
        width: 60px;
        height: 60px;
        background: #ffffff;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        margin-bottom: 10px;
        animation: moveUpDown 0.3s ease-in-out 0.3s;

        .icon-img {
          transform: scale(0.33);
        }
      }

      .item-icon:active {
        transform: scale(0.95);
      }

      .item-name {
        text-align: center;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.7);
        line-height: 17px;
      }
    }
  }
}

@keyframes moveup {
  0% {
    transform: translateY(100%);
  }

  100% {
    transform: translateY(0%);
  }
}

@keyframes moveUpDown {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }

  70% {
    opacity: 1;
    transform: translateY(-20px);
  }

  100% {
    transform: translateY(0);
  }
}
</style>
